import { templateMap } from 'Views/Page/Content/Templates/templates';

// These are the only props that are permitted to be passed to each of the different types of modals. We hope to keep
// the modal interface simpler going forward and avoid supporting a never-ending number of props for one-off use cases.
// These should not be modified or changed without very careful consideration.
const commonAllowedKeys = new Set(['Layout', 'metaOverrideSet', 'modalSize', 'modalType', 'fixedHeight', 'closeOnBackdropClick', 'color']);
const legacyAllowedKeys = new Set([...commonAllowedKeys, 'forceFullScreen', 'limitedMaxHeight', 'onlyRenderLayout', 'forceNotFullScreen', 'disableBackdropClickClosure']);
const drawerAllowedKeys = new Set([...commonAllowedKeys, 'variant', 'anchor']);
const takeoverAllowedKeys = new Set([...commonAllowedKeys, 'padding']);
const standardAllowedKeys = new Set([...commonAllowedKeys, 'forceNotFullScreen', 'noCloseButton']);
const celebrationAllowedKeys = new Set([...commonAllowedKeys, 'noCloseButton']);
const invisibleAllowedKeys = new Set(['Layout', 'modalType']);

for (const resourceType of Object.keys(templateMap)) {
  if (!('modal' in templateMap[resourceType])) {
    continue; // skip anything with only a page template defined; we don't have any validation defined for page templates
  }
  const returnedObj = templateMap[resourceType].modal;

  const modalType = returnedObj.modalType || 'standard';
  let allowedKeys;
  switch (modalType) {
    case 'drawer':
      allowedKeys = drawerAllowedKeys;
      break;
    case 'takeover':
      allowedKeys = takeoverAllowedKeys;
      break;
    case 'legacy':
      allowedKeys = legacyAllowedKeys;
      break;
    case 'celebration':
      allowedKeys = celebrationAllowedKeys;
      break;
    case 'standard':
      allowedKeys = standardAllowedKeys;
      break;
    case 'invisible':
      allowedKeys = invisibleAllowedKeys;
      break;
    default:
      throw new Error(`Unexpected modalType ${modalType} returned from getModalLayout for modal resource ${resourceType}`);
  }
  for (const [key] of Object.entries(returnedObj)) {
    if (!allowedKeys.has(key)) {
      throw new Error(`Found unexpected key ${key} in the modal props object returned from getModalLayout for modal resource ${resourceType}`);
    }
  }
}
